import axios from "axios";
import React, { useEffect, useState } from "react";
import AuditionIncome from "./Screen/StarAuditionIncome";
// import AuditionIncome from "./Screen/AuditionIncome";
import FanGroupIncome from "./Screen/FanGroupIncome";
import GreetingIncome from "./Screen/GreetingIncome";
import Income from "./Screen/Income";
import LearningSessionIncome from "./Screen/LearningSessionIncome";
import LiveChatIncome from "./Screen/LiveChatIncome";
import MeetupEventIncome from "./Screen/MeetupEventIncome";
import PostIncome from "./Screen/PostIncome";
import QnAIncome from "./Screen/QnAIncome";
// import Schedule from "./Screen/Schedule";
import StarSchedule from "./Screen/StarSchedule";
import StarShowcaseIncome from "./Screen/StarShowcaseIncome";
import "./Screen/stylesScreen.css";
import Wallet from "./Screen/Wallet";
const MainDashboard = () => {
  const [totalIncomeData, setTotalIncomeData] = useState();
  const [simplePostIncome, setSimplePostIncome] = useState();
  const [liveChatIncome, setLiveChatIcome] = useState();
  const [qnaIncome, setqnaIcome] = useState();
  const [meetupIncome, setMeetupIcome] = useState();
  const [greetingIncome, setGreetingIcome] = useState();
  const [learningIncome, setLearningIcome] = useState();
  const [fanGroupIncome, setfanGroupIncome] = useState();
  const [starShowcase, setStarShowcase] = useState();

  useEffect(() => {
    axios.get("/api/star/dashboard").then((res) => {
      if (res.data.status === 200) {
        setTotalIncomeData(res.data.totalIncomeStatement);
        setSimplePostIncome(res.data.simplepost);
        setLiveChatIcome(res.data.liveChat);
        setqnaIcome(res.data.qna);
        setMeetupIcome(res.data.meetup);
        setGreetingIcome(res.data.greeting);
        setLearningIcome(res.data.learning);
        setfanGroupIncome(res.data.learning);
        setStarShowcase(res.data.totalIncomeStatementStarShowcase);
      }
    });
  }, []);

  return (
    <>
      <div className="card-bg px-3 py-2">
        <Income props={totalIncomeData} />
      </div>

      {/* <div className="bg-dark px-3 pt-4 pb-1">
        <Wallet props={totalIncomeData} />
      </div> */}

      <div className=" px-3 pt-4 pb-1 card-bg">
        {" "}
        <StarSchedule />{" "}
      </div>

      <div className="mb-3">
        <div className=" px-3 pt-4 pb-1 card-bg mt-3">
          <PostIncome props={simplePostIncome} />
        </div>
        {/* <div className=" px-3 pt-4 pb-1 card-bg mt-3">
          <AuditionIncome />
        </div> */}
        <div className=" px-3 pt-4 pb-1 card-bg mt-3">
          <LiveChatIncome props={liveChatIncome} />
        </div>
        <div className=" px-3 pt-4 pb-1 card-bg mt-3">
          <MeetupEventIncome props={meetupIncome} />
        </div>
        <div className=" px-3 pt-4 pb-1 card-bg mt-3">
          <LearningSessionIncome props={learningIncome} />
        </div>
        <div className=" px-3 pt-4 pb-1 card-bg mt-3">
          <GreetingIncome props={greetingIncome} />
        </div>
        <div className=" px-3 pt-4 pb-1 card-bg mt-3">
          <StarShowcaseIncome props={starShowcase} />
        </div>
        {/* <div className=" px-3 pt-4 pb-1 card-bg mt-3">
          <FanGroupIncome props={fanGroupIncome}/>
        </div> */}
        <div className=" px-3 pt-4 pb-1 card-bg mt-3">
          <QnAIncome props={qnaIncome} />
        </div>
      </div>
    </>
  );
};

export default MainDashboard;
